import { render, staticRenderFns } from "./PieChartDashboard.vue?vue&type=template&id=7fde0b84"
import script from "./PieChartDashboard.vue?vue&type=script&lang=js"
export * from "./PieChartDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports